import React from 'react';
import { Button, Col, Input, Label, Row } from 'reactstrap';

import styles from './style.module.scss';

import { FindSelectedElement } from '../../../helpers/Helpers';

interface Props {
  title: string;
  dataSource: any;
  lastLevel: number;
  securityLevel?: number;
  onHideSidebar: () => void;
  onNext: (dataSource) => void;
  onSave: (data) => void;
  isProductFilter?: boolean; // Useed to determine if the filter is for product hierarchy
}

interface State {
  dataSource: any;
  selectedItem: any;
  currentItem: string;
  currentLevel: number;
  levelList: string[];
  selectedLevelCodeList: string[];
  codeHierarchyList: string[];
  isLastLevel: boolean;
  filteredDataSource: any;
}

export default class SingleSelectRadioSidebar extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      dataSource: this.props.dataSource,
      selectedItem: this.props.dataSource,
      currentItem: '',
      currentLevel: 1,
      levelList: [],
      selectedLevelCodeList: [],
      codeHierarchyList: [],
      isLastLevel: false,
      filteredDataSource: []
    };
  }

  componentDidMount(): void {
    this.state.levelList.push(this.state.selectedItem[0].name);
    this.setState({ levelList: this.state.levelList });
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if (this.props.dataSource !== prevProps.dataSource) {
      this.setState({
        dataSource: this.props.dataSource
      }, () => {
        this.updateParentJSON(this.state.dataSource);
      });
    }
  }

  hideRightSidebar(): void {
    this.props.onHideSidebar();
  }

  onUpdateCheckbox(e, code: string): void {
    this.state.selectedItem.map((item) => item.selected = false);
    const itemIdx = this.state.selectedItem.findIndex((item) => item.code === code);
    this.state.selectedItem[itemIdx].selected = e.target.checked;
    this.setState({ selectedItem: this.state.selectedItem });
  }

  updateParentJSON(selectedItem): void {
    selectedItem.forEach((item) => {
      if (item.level === this.state.currentLevel && item.selected) {
        this.setState({
          selectedItem
        }, () => {
          this.state.levelList.push(item.children[0].name);
          this.setState({
            currentLevel: item.children[0].level,
            currentItem: item.children[0].name,
            levelList: this.state.levelList,
            selectedItem: item.children,
            isLastLevel: item.children[0].level === this.props.lastLevel
          });
        });
        return;
      } else {
        !!item.children.length && this.updateParentJSON(item.children);
      }
    });
  }

  disableNextButton(): boolean {
    return this.state.selectedItem.filter((item) => item.selected).length == 0;
  }

  userAccess(): boolean {
    if (this.props.title === 'Location') {
      return [
        '#/sales-plan',
        '#/sales-plan/edit-all',
        '#/sku-level-sales-plan',
        '#/sku-level-sales-plan-edit-all',
        '#/rolling-plan',
        '#/rolling-plan/edit-all',
        '#/sku-level-rolling-plan',
        '#/sku-level-rolling-plan-edit-all',
        '#/strategic-plan',
        '#/strategic-plan/edit-all',
        '#/manage-single-select-product',
        '#/run-rate-plan',
      ].includes(window.location.hash);
    } else {
      return [
        '#/sku-level-sales-plan',
        '#/sku-level-rolling-plan',
        '#/sku-level-sales-plan-edit-all',
        '#/sku-level-rolling-plan-edit-all',
        '#/manage-single-select-product',
        '#/run-rate-plan',
      ].includes(window.location.hash);
    }
  }

  userWithFullAccess(): boolean {
    if (this.props.title === 'Location') {
      return [
        '#/sales-plan',
        '#/sales-plan/edit-all',
        //'#/sku-level-sales-plan',
        //'#/sku-level-sales-plan-edit-all',
        '#/rolling-plan',
        '#/rolling-plan/edit-all',
        //'#/sku-level-rolling-plan',
        //'#/sku-level-rolling-plan-edit-all',
        '#/strategic-plan',
        '#/strategic-plan/edit-all',
        //'#/manage-single-select-product',
      ].includes(window.location.hash);
    } else {
      return false;
    }
  }


  nextButtonValidity(): boolean {
    const canProceed = this.userAccess() && this.state.currentLevel >= 3;
    return canProceed || this.disableNextButton();
  }

  submitButtonVisibilityForUser(): boolean {
    return (sessionStorage.getItem('isAdminUser') === 'true' && this.userWithFullAccess());
  }
  disableSubmitButton(): boolean {
    const canSubmit = this.submitButtonVisibilityForUser() ? false : this.userAccess()
      ? (this.state.currentLevel < 3 || this.state.currentLevel === 4)
      : false;
    return canSubmit || this.disableNextButton();
  }

  recursiveBack(selectedItem): void {
    let prevItem = selectedItem
      .filter((item) => item.level === this.state.currentLevel - 1);
    prevItem.forEach((item) => {
      item.children = []
    });

    if (!!prevItem.length) {
      this.setState({
        currentLevel: this.state.currentLevel - 1,
        currentItem: (this.state.currentLevel - 1 > 1) ? prevItem[0].name : '',
        selectedItem: prevItem,
        isLastLevel: (this.state.currentLevel - 1) === this.props.lastLevel
      });
    } else {
      selectedItem.forEach((item) => {
        item.selected && this.recursiveBack(item.children);
      });
    }
  }

  onPrev(): void {
    this.state.levelList.pop();
    this.recursiveBack(this.state.dataSource);
  }

  onNext(code: string): void {
    this.state.selectedItem.map((item) => item.selected = false);
    const itemIdx = this.state.selectedItem.findIndex((item) => item.code === code);
    this.state.selectedItem[itemIdx].selected = true;
    this.setState({
      selectedItem: this.state.selectedItem
    }, () => {
      this.props.onNext(this.state.dataSource);
    });
  }

  onSave(): void {
    const dataSource = FindSelectedElement(this.state.dataSource, ({ selected }) => selected);
    this.props.onSave(dataSource);
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div className="right-bar">

          <div className="h-100 position-relative">
            <div className="rightbar-title px-3 pt-4">
              <h5 className="m-0">{this.props.title}</h5>
              <div
                className="right-bar-toggle"
                onClick={() => this.hideRightSidebar()}
              >
                <i className="mdi mdi-close"/>
              </div>
            </div>

            <div className="px-3">
              <span data-mm={this.state.levelList}/>
              {
                this.state.levelList.map((name, idx) => (
                  <span key={idx} data-mm={this.state.levelList}>
                    <span className={
                      this.state.levelList.length - 1 !== idx
                        ? 'text-primary cursor-pointer'
                        : ''}
                    >
                      {name}
                    </span>
                    {
                      this.state.levelList.length - 1 !== idx &&
                      <i className="ri-arrow-drop-right-line align-middle font-size-14"/>
                    }
                  </span>
                ))
              }
              {
                this.userAccess() &&
                <p className="text-danger mb-0 mt-1"> 
                  {`${this.props.title === 'Location' && !this.submitButtonVisibilityForUser() ? '*Country is mandatory selection' : this.props.title === 'Product' ? '*Sub class is mandatory selection' : ''}`}
                </p>
              }
            </div>

            <div className="rightbar-body p-3">
              <p className={styles['level-header']}>{this.state.currentItem}</p>
              {
                this.state.selectedItem.map((item, idx: number) => (
                  <div
                    key={idx}
                    className={styles['item-container']}
                  >
                    <Input
                      type="radio"
                      checked={item.selected}
                      onChange={(e) => this.onUpdateCheckbox(e, item.code)}
                      className="me-1"
                      name="item-radio"
                    />
                    <Label
                      className={`${styles['item-label']} ${!this.state.isLastLevel ? 'cursor-pointer' : 'cursor-not-allowed'}`}
                      disabled={this.nextButtonValidity()}
                      onClick={() => !this.state.isLastLevel && this.onNext(item.code)}
                    >
                      {this.props.title === 'Location' ? item.value : item.code}
                    </Label>
                  </div>
                ))
              }

              <div className={`${styles['footer-button']} px-3`}>
                <Row>
                  <Col md={6} className="d-flex align-items-center">
                    <Button
                      color={'primary'}
                      outline
                      className="btn btn-primary-outline me-2"
                      onClick={() => this.hideRightSidebar()}
                    >
                      Cancel
                    </Button>
                    {
                      this.state.currentLevel > 1 &&
                      <Button
                        color={'primary'}
                        outline
                        className="btn btn-primary-outline d-flex"
                        onClick={() => this.onPrev()}
                      >
                        <i className="ri-arrow-left-line me-2"/> Prev
                      </Button>
                    }
                  </Col>

                  <Col md={6} className="d-flex align-items-center justify-content-end">
                    {/*{
                      !this.state.isLastLevel &&
                      <Button
                        color={'primary'}
                        outline
                        className="btn btn-primary-outline me-2 d-flex"
                        disabled={this.nextButtonValidity()}
                        onClick={() => this.onNext()}
                      >
                        Next <i className="ri-arrow-right-line ms-2"/>
                      </Button>
                    }*/}
                    <Button
                      color={'primary'}
                      className="btn btn-primary"
                      disabled={this.disableSubmitButton()}
                      onClick={() => {
                        if (this.props.isProductFilter) {
                          this.props.onSave(FindSelectedElement(this.state.dataSource, ({ selected }) => selected));
                        } else {
                          this.onSave();
                        }
                      }}
                    >
                      {this.props.isProductFilter ? 'Apply' : 'Select'}
                    </Button>
                  </Col>
                </Row>
              </div>

            </div>
          </div>
        </div>

        <div className="rightbar-overlay"/>
      </React.Fragment>
    );
  }
}
